/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsListPaged } from '../../models/news-list-paged';
import { SortDirection } from '../../models/sort-direction';

export interface ListNews$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the news's name
 *   * CREATED_DATE : Date when the news was configured
 *   * PLANNED_DATE : Date when the news will be published
 *   * CATEGORY : Category of the news
 */
  sortFieldName?: 'NAME' | 'CREATED_DATE' | 'PLANNED_DATE' | 'CATEGORY';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * If not specified, all News will be returned, if true only planned news, if false only news that are sent
 */
  plannedNewsFilter?: boolean;
}

export function listNews(http: HttpClient, rootUrl: string, params?: ListNews$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsListPaged>> {
  const rb = new RequestBuilder(rootUrl, listNews.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('plannedNewsFilter', params.plannedNewsFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsListPaged>;
    })
  );
}

listNews.PATH = '/news';
